import { Col, Drawer, Row, Space, Typography } from "antd";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import MessageList from "./Components/UserList/UserList";
import MessageDetails from "./Components/Messge/MessageDetails";
import MazakaCard from "apps/Common/MazakaCart";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { useGetMessageGroups } from "./ServerSideStates";
import PageTitle from "apps/Common/PageTitle";
import MobileMessageDrawer from "./Components/Messge/MobileMessageDrawer";
import { Helmet } from "react-helmet-async";


const MessageIndex = () => {
  const { Text } = Typography;
  const { userFilter } = useSelector((state: RootState) => state.message);
  const messageGroups = useGetMessageGroups(userFilter);
  const screens = useBreakpoint(); // Ekran boyutlarını al

  // Sadece xs, sm ve md boyutlarında mobil drawer göster
  const showMobileDrawer = screens.xs;

  return (
    <>
      <Col xs={24} className="!p-0" >
        <Helmet>
          <title className="capitalize">{"Mesajlarım"}</title>
        </Helmet>
        <Row 
          gutter={[
            { xs: 10, md:10 , xl:10 }, 
            { xs:10 , md: 15, xl:20}   
          ]}
          className="!overflow-hidden"
        >
          <Col span={24} className="!flex justify-center">
            <PageTitle
              title="Mesaj Listesi"
              count={messageGroups?.data?.data?.data.length || 0}
            />
          </Col>

          <Col xs={24} className="!overflow-hidden">
            <Row gutter={[40, 40]}>
              <Col xs={24} lg={7} className="!bg-[#f5f5f5]">
                <MessageList />
              </Col>
              <Col xs={24} lg={17} className="!hidden xl:!block">
                <MessageDetails />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      
      {/* Sadece mobil boyutlarda göster */}
      {showMobileDrawer && <MobileMessageDrawer />}
    </>
  );
};

export default MessageIndex;